module.exports = __webpack_public_path__ + "static/img/Alcean_logo.619701d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Alcean_logo.png
// module id = eN+8
// module chunks = 0